import { render, staticRenderFns } from "./Jogo.vue?vue&type=template&id=e62313d8&scoped=true&"
import script from "./Jogo.vue?vue&type=script&lang=js&"
export * from "./Jogo.vue?vue&type=script&lang=js&"
import style0 from "./Jogo.vue?vue&type=style&index=0&id=e62313d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62313d8",
  null
  
)

export default component.exports